import { useQuery } from "@tanstack/react-query";
import { activitySidebarService } from "../../services/activitySidebar.service";

// SIMS-4154 (polling-first): the backend cannot host WebSockets on Lambda, so
// the sidebar refreshes by polling. 30s keeps it near-real-time without new infra.
const POLL_INTERVAL_MS = 30_000;

export const useActivitySidebar = (coordinatorId: string | undefined) => {
	return useQuery({
		queryKey: ["sims-activity-sidebar", coordinatorId],
		queryFn: () =>
			activitySidebarService.getActivitySidebar(coordinatorId as string),
		enabled: Boolean(coordinatorId),
		staleTime: 15_000,
		gcTime: 300_000,
		refetchInterval: POLL_INTERVAL_MS,
		// Pause the poll while the tab is hidden (also the v5 default) so we
		// don't keep hitting the API for a sidebar the user can't see.
		refetchIntervalInBackground: false,
		refetchOnWindowFocus: true,
	});
};
